import React from "react"
import { OtherBenefitsContainer, Wrapper, TextBox } from "./styles"
import CompoundWaves from "../../img/compound_details_waves.svg"
import { Row, Col } from "react-bootstrap"
import { renderHTML } from "../../agility/utils"
import CompoundDetailsText from "./CompoundDetailsText"
import { Link } from "gatsby"

const CompoundDetails = ({ item, dynamicPageItem }) => {
  // get single compound dynamic item
  const compound = dynamicPageItem.customFields

  return (
    <OtherBenefitsContainer img={CompoundWaves}>
      <Wrapper>
        <h1>{compound.title}</h1>
        <Row>
          <Col lg={5} className="compound-image">
            <img src={compound.mobileImage.url} alt={compound.title} />
          </Col>
          <Col lg={7}>
            <TextBox>
              <CompoundDetailsText text={compound.text} />
            </TextBox>
            {compound.otherBenefitsText ? (
              <>
                <h5>Other Benefits Include:</h5>
                <TextBox>
                  <div
                    dangerouslySetInnerHTML={renderHTML(
                      compound.otherBenefitsText
                    )}
                  />
                </TextBox>
              </>
            ) : null}
            <div className="back-btn">
              <Link to="/science" title="Back To Science">
                Return to Compounds List
              </Link>
            </div>
          </Col>
        </Row>
      </Wrapper>
    </OtherBenefitsContainer>
  )
}

export default CompoundDetails
